import * as types from '@/store/mutation-types';

const mutations = {
  [types.SET_VIDEO_URL](state, p) {
    const drp = p.drp;
    drp.videoFile = p.videoFile;
  },
};

const actions = {
  setVideoFile: ({ commit }, payload) => {
    commit(types.SET_VIDEO_URL, payload);
  },
};

export default {
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/video-player/vuex.js